module.exports = __webpack_public_path__ + "static/img/u222_01.48e3fa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u222_01.jpg
// module id = WG+w
// module chunks = 0